module.exports = __webpack_public_path__ + "img/cash-clock.9b88ef60.svg";